/* eslint-disable no-unused-vars */
import { Pagination, Space, Table, Tooltip } from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { AiOutlineEye, AiOutlineSync } from "react-icons/ai";
import { BiPowerOff } from "react-icons/bi";
import { FcMoneyTransfer } from "react-icons/fc";
import { GiPadlock, GiPadlockOpen } from "react-icons/gi";
import { HiOutlineUserGroup } from "react-icons/hi";
import { MdPayment } from "react-icons/md";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import Select from "react-select";
import SuspendModal from "../../../../components/modals/SuspendModal";
import {
  findCustomersUsers,
  getAllCustomers,
} from "../../../../store/actions/users.action";
import TransactionSummary from "../../home/atom/customer/TransactionSummary";

import { customerOptionsDropdown } from "../../../../utils/helpers/objectHelpers";
import { EmployeeService } from "../../../../utils/services/employees.service";

const Body = ({
  domainBrand,
  customers = [],
  sizeOfList,
  setPageSize,
  isLoading,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { Column } = Table;
  const menuPortalTarget = document.getElementById("root");
  const [transactionInfo, updateTransactionInfo] = useState([]);
  const [filterInput, setFilterInput] = useState("");
  const [customerOption, setCustomerOption] = useState("");
  const [id, setId] = useState("");
  const [employeeObject, setEmployeeObject] = useState({});
  const [type, setType] = useState("");
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [reset, setReset] = useState(false);
  // const [loadingCustomers, updateLoadingCustomers] = useState(false);
  const dictionary = domainBrand.domainBrand["languageDictionary"];
  const languageStatus = !(
    typeof dictionary === "undefined" || dictionary === null
  );
  const customerOptions = customerOptionsDropdown(languageStatus, dictionary);

  useEffect(() => {
    updateTransactionInfo([]);
  }, []);

  const handleDisableOtp = async (id) => {
    setLoading(true);
    try {
      const response = await EmployeeService.disableOtp(id);
      if (response.data.status === "SUCCESS") {
        toast.success("OTP disabled successfully");
        dispatch(getAllCustomers("BOTH", 20, 1));
      } else {
        toast.error(response.data.message);
      }
      setLoading(false);
      setOpen(false);
    } catch (error) {
      setLoading(false);
      setOpen(false);
      return error;
    }
    setLoading(false);
  };

  const handlePasswordReset = async (id) => {
    setLoading(true);
    try {
      const response = await EmployeeService.allowPasswordReset(id);
      if (response.data.status === "SUCCESS") {
        toast.success("Password reset enabled successfully");
        dispatch(getAllCustomers("BOTH", 20, 1));
      } else {
        toast.error(response.data.message);
      }
      setLoading(false);
      setOpen(false);
    } catch (error) {
      setLoading(false);
      setOpen(false);
      return error;
    }
    setLoading(false);
  };

  const handleSuspend = async (id) => {
    setLoading(true);
    try {
      const response = await EmployeeService.suspendEmployee(id);
      if (response.data.status === "SUCCESS") {
        toast.success("Employee deactivated successfully");
        // dispatch(getAllCustomers("BOTH", 20, 1));
      } else {
        toast.error(response.data.message);
      }
      setLoading(false);
      setOpen(false);
    } catch (error) {
      setLoading(false);
      setOpen(false);
      return error;
    }
    setLoading(false);
  };

  const handleDuplicateLogin = async (id) => {
    setLoading(true);
    try {
      const response = await EmployeeService.allowDuplicateLogin(id);
      if (response.data.status === "SUCCESS") {
        toast.success("Duplicate login successfully enabled.");
        // dispatch(getAllCustomers("BOTH", 20, 1));
      } else {
        toast.error(response.data.message);
      }
      setLoading(false);
      setOpen(false);
    } catch (error) {
      setLoading(false);
      setOpen(false);
      return error;
    }
    setLoading(false);
  };

  const handleUnsuspend = async (id) => {
    setLoading(true);
    try {
      const response = await EmployeeService.activateEmployee(id);
      if (response.data.status === "SUCCESS") {
        toast.success("Employee activated successfully");
        // dispatch(getAllCustomers("BOTH", 20, 1));
      } else {
        toast.error(response.data.message);
      }
      setLoading(false);
      setOpen(false);
    } catch (error) {
      setLoading(false);
      setOpen(false);
      return error;
    }
    setLoading(false);
  };

  const tableData =
    customers &&
    customers?.map((i, index) => {
      return { ...i, key: index + 1 };
    });

  const onChange = (page) => {
    // setPageSize(page);
    dispatch(getAllCustomers("BOTH", 20, page));
  };

  const onFilter = async (e) => {
    const criteria = e.target.value;
    try {
      if (criteria === "") {
        dispatch(getAllCustomers("BOTH", 20, 1));
      }
      dispatch(findCustomersUsers(criteria));
    } catch (error) {
      return [];
    }
  };

  return (
    <React.Fragment>
      <SuspendModal
        type={type}
        handleSuspend={() => handleSuspend(id)}
        handleUnsuspend={() => handleUnsuspend(id)}
        handleDisableOtp={() => handleDisableOtp(id)}
        handlePasswordReset={() => handlePasswordReset(id)}
        handleDuplicateLogin={() => handleDuplicateLogin(id)}
        show={open}
        handleClose={() => [setOpen(false)]}
        employee={{
          firstName:
            employeeObject?.firstName !== undefined
              ? employeeObject?.firstName
              : "",
          lastName:
            employeeObject?.lastName !== undefined
              ? employeeObject?.lastName
              : "",
        }}
        loading={loading}
      />
      <div className="app-content hor-content">
        <div className="container">
          <div className="page-header">
            <div>
              <h1 className="page-title">
                {languageStatus
                  ? dictionary["para_manage_customers"]
                  : "Customers"}
              </h1>
            </div>
            <div className="ms-auto pageheader-btn" />
          </div>
          <div className="row">
            <div className="col-lg-12 col-md-12">
              <div className="card overflow-hidden">
                <div className="card-header bg-primary text-white">
                  <h3 className="card-title">
                    <span className="">
                      {languageStatus
                        ? dictionary["l_customer_information"]
                        : "Customer Information"}
                    </span>
                  </h3>
                </div>
                <div className="card-body pb-0 pt-4">
                  <TransactionSummary graphData={transactionInfo} />
                </div>
              </div>
              <div className="card overflow-hidden">
                <div className="card-header bg-primary text-white">
                  <h3 className="card-title">
                    <span className="">
                      {languageStatus
                        ? dictionary["m_manage_customer"]
                        : "Customers"}
                    </span>
                  </h3>
                </div>
                <div className="card-body pb-0 pt-4">
                  <div className="needs-validation">
                    <div
                      className="row form-row"
                      style={{
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <div className="col-md-3 mb-3">
                        <label>
                          {languageStatus
                            ? dictionary["l_customer_type"]
                            : "Customer Type"}
                        </label>
                        <Select
                          options={customerOptions}
                          isClearable={false}
                          isSearchable={false}
                          maxMenuHeight={250}
                          menuPlacement="bottom"
                          menuPortalTarget={menuPortalTarget}
                          name="selectedCurrency"
                          value={customerOption}
                          onChange={async (option) => {
                            setCustomerOption(option);
                            // await dispatch(
                            //   getAllCustomers(option.value, pageSize.value)
                            // );
                            await dispatch(
                              getAllCustomers(option.value, 10, 1)
                            );
                          }}
                        />
                      </div>
                      <div className="col-md-3 mb-3" />

                      <div className="col-4 ml-auto mb-3">
                        <label>
                          {languageStatus ? dictionary["l_filter"] : "Filter"}
                        </label>
                        <input
                          type="search"
                          value={filterInput}
                          onChange={(event) => {
                            setFilterInput(event.target.value);
                            onFilter(event);
                          }}
                          className="form-control form-control-sm"
                          placeholder="Search or filter by name or customerId..."
                        />
                      </div>
                    </div>
                  </div>

                  <div className="table-responsive mt-3">
                    <Table
                      dataSource={tableData}
                      className="w-100 table tbody"
                      loading={isLoading}
                      pagination={false}
                    >
                      <Column
                        title="Last Login"
                        dataIndex="lastLoginTime"
                        key="1"
                        className=""
                        render={(text) => {
                          return (
                            <span className="text-lowercase whitespace">
                              {moment(text).format("DD/MM/YYYY")}
                            </span>
                          );
                        }}
                        sorter={(a, b) => a.lastLoginTime - b.lastLoginTime}
                      />
                      <Column
                        title="Full Name"
                        dataIndex="fullName"
                        key="2"
                        className=""
                        render={(text, record) => {
                          return (
                            <span className="text-lowercase whitespace">
                              {record.firstName}&nbsp;&nbsp;{record.lastName}
                            </span>
                          );
                        }}
                        sorter={(a, b) => a.firstName - b.firstName}
                      />
                      <Column
                        title="Email"
                        dataIndex="email"
                        key="3"
                        className=""
                        sorter={(a, b) => a.email - b.email}
                      />
                      <Column
                        title="Phone"
                        dataIndex="phone"
                        key="4"
                        className=""
                        sorter={(a, b) => a.phone - b.phone}
                      />
                      <Column
                        title="Action"
                        dataIndex="action"
                        key="5"
                        className=""
                        render={(text, record) => {
                          return (
                            <>
                              <Space size="small">
                                <Tooltip
                                  title={"View"}
                                  color="#212529"
                                  placement="bottom"
                                  arrowPointAtCenter={true}
                                >
                                  <AiOutlineEye
                                    color={"#6259CA"}
                                    fontSize={20}
                                    fill={"#6259CA"}
                                    className="cursor-pointer"
                                    // onClick={() =>
                                    //   history.push(
                                    //     `/customer/${record.customerId}`
                                    //   )
                                    // }
                                  />
                                </Tooltip>
                                {record.status === "DEACTIVATED" ? (
                                  <Tooltip
                                    title={"Activate employee"}
                                    color="#212529"
                                    placement="bottom"
                                    arrowPointAtCenter={true}
                                  >
                                    <GiPadlockOpen
                                      color={"#6259CA"}
                                      fontSize={20}
                                      fill={"#6259CA"}
                                      className="cursor-pointer"
                                      onClick={() => {
                                        setType("ACTIVATE-EMPLOYEE");
                                        setId(record?.customerId);
                                        setOpen(true);
                                        setEmployeeObject({ ...record });
                                      }}
                                    />
                                  </Tooltip>
                                ) : (
                                  <Tooltip
                                    title={"Deactivate employee"}
                                    color="#212529"
                                    placement="bottom"
                                    arrowPointAtCenter={true}
                                  >
                                    <GiPadlock
                                      color={"#6259CA"}
                                      fontSize={20}
                                      className="cursor-pointer"
                                      fill={"#6259CA"}
                                      onClick={() => {
                                        setType("SUSPEND-EMPLOYEE");
                                        setId(record?.customerId);
                                        setOpen(true);
                                        setEmployeeObject({ ...record });
                                      }}
                                    />
                                  </Tooltip>
                                )}
                                <Tooltip
                                  title={"Allow duplicate login"}
                                  color="#212529"
                                  placement="bottom"
                                  arrowPointAtCenter={true}
                                >
                                  <HiOutlineUserGroup
                                    color={"#6259CA"}
                                    fontSize={20}
                                    className="cursor-pointer"
                                    fill={"#6259CA"}
                                    onClick={() => {
                                      setType("DUPLICATE-LOGIN");
                                      setId(record?.customerId);
                                      setOpen(true);
                                      setEmployeeObject({ ...record });
                                    }}
                                  />
                                </Tooltip>

                                <Tooltip
                                  title={"Disable otp"}
                                  color="#212529"
                                  placement="bottom"
                                  arrowPointAtCenter={true}
                                >
                                  <BiPowerOff
                                    color={"#6259CA"}
                                    fontSize={22}
                                    className="cursor-pointer"
                                    fill={"#6259CA"}
                                    onClick={() => {
                                      setType("DISABLE-OTP");
                                      setId(record?.customerId);
                                      setOpen(true);
                                      setEmployeeObject({ ...record });
                                    }}
                                  />
                                </Tooltip>

                                <Tooltip
                                  title={"Password reset"}
                                  color="#212529"
                                  placement="bottom"
                                  arrowPointAtCenter={true}
                                >
                                  <AiOutlineSync
                                    color={"#6259CA"}
                                    fontSize={20}
                                    fill={"#6259CA"}
                                    onClick={() => {
                                      setType("PASSWORD-RESET");
                                      setId(record?.customerId);
                                      setOpen(true);
                                      setEmployeeObject({ ...record });
                                      setReset(true);
                                    }}
                                    className={`${
                                      reset ? "reset-password-icon" : ""
                                    } cursor-pointer`}
                                  />
                                </Tooltip>

                                <Tooltip
                                  title={"Fund Account"}
                                  color="#212529"
                                  placement="bottom"
                                  arrowPointAtCenter={true}
                                >
                                  <FcMoneyTransfer
                                    fontSize={25}
                                    color={"#6259CA"}
                                    className="cursor-pointer"
                                  />
                                </Tooltip>

                                <Tooltip
                                  title={"Withdraw from account"}
                                  color="#212529"
                                  placement="bottom"
                                  arrowPointAtCenter={true}
                                >
                                  <MdPayment
                                    fontSize={25}
                                    color={"#6259CA"}
                                    className="cursor-pointer"
                                  />
                                </Tooltip>
                              </Space>
                            </>
                          );
                        }}
                      />
                    </Table>
                  </div>
                  <Pagination
                    total={sizeOfList}
                    responsive
                    onChange={(page) => {
                      onChange(page, 10);
                    }}
                    className="float-end pt-1 pb-4"
                    showTotal={(total, range) =>
                      `Showing ${range[0]}-${range[1]} of ${total} items`
                    }
                    showSizeChanger={false}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Body;
